import React, { useEffect, useState, useContext, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Button from '@components/Button';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import FontReplacementItem from './FontReplacementItem';
import { IIncompatibleFontReplace } from '../../types';

const FontReplacement:React.FC<IProps> = (props) => {

  const AllUndefined = (incompatibleFonts: IIncompatibleFontReplace[]) => {
    for(let i=0;i<incompatibleFonts.length;i++) {
      if (incompatibleFonts[i].fontReplace !== undefined) {
        return false;
      }
    }
    return true;
  }

  return (
    <S.Root>
      <S.WarningBox>
      <S.Title>
          {'Replace Fonts'}
        </S.Title>
        <S.Content>
          <S.Message>
            {'Incompatible fonts were found in your file. Would you like to replace the fonts?'}
          </S.Message>
          <S.FontsReplaceList>
            {
              props.incompatibleFonts.sort((a, b) => {
                var textA = a.incompatibleFont.toUpperCase();
                var textB = b.incompatibleFont.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
              }).map((incompatibleFont, index) => {
                return (
                  <FontReplacementItem index={index} incompatibleFontReplace={incompatibleFont} onFontSelect={props.onFontSelect} />
                )
              })
            }
          </S.FontsReplaceList>
          <S.ActionsContainer>
            <S.Action>
              <Button
                label={'IGNORE'}
                style={{
                  marginRight: 12, 
                  backgroundColor: "transparent", 
                  border: `1px solid ${C.DARK_ORANGE}`, 
                  hoverBackgroundColor: `${C.DARK_ORANGE}22`,
                  width: `125px`
                }}
                labelStyle={{ color: C.DARK_ORANGE }}
                onClick={props.onClickIgnore}
              />
            </S.Action>
            <S.Action>
              <Button
                label={'REPLACE'}
                style={{
                  backgroundColor: C.DARK_ORANGE, 
                  flexGrow: 0, 
                  hoverBackgroundColor: `${C.DARK_ORANGE}AA`,
                  width: `125px`
                }} 
                disabled={AllUndefined(props.incompatibleFonts)}
                onClick={AllUndefined(props.incompatibleFonts)?()=>{}:props.onClickReplace}
              />
            </S.Action>
          </S.ActionsContainer>
        </S.Content>
      </S.WarningBox>
    </S.Root>
  );
}

export default FontReplacement